import initialState from '../store/initial-state'
import {
  VALIDATE_INVITE,
  VALIDATE_INVITE_SUCCES,
  VALIDATE_INVITE_FAILURE,
  REGISTER_INVITE,
  REGISTER_INVITE_FAILURE,
  REGISTER_INVITE_SUCCESS,
  REGISTER_INVITE_DONE
} from '../constants/invite-types'



export default (state = initialState.invitation, action) => {
  switch (action.type) {

    case VALIDATE_INVITE:
      return {
        ...state,
        loading: true,
        validate: false
      };

    case VALIDATE_INVITE_FAILURE:
      return {
        ...state,
        loading: false,
        validate: false,
        error: action.payload.error
      };

    case VALIDATE_INVITE_SUCCES:
      return {
        ...state,
        loading: false,
        user: action.payload.user,
        accessToken: action.payload.accessToken,
        group: action.payload.group,
        validate: false
      };

    case REGISTER_INVITE:
      return {
        ...state,
        loading: true,
        validate: false
      };

    case REGISTER_INVITE_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error
      };

    case REGISTER_INVITE_SUCCESS:
      return {
        ...state,
        loading: false,
        user: action.payload.user,
        validate: action.payload.validate,
        headers: action.payload.headers

      };

    case REGISTER_INVITE_DONE:
      return {
        ...state,
        loading: false,
        user: null,
        validate: null,
        headers: null,
        error: null,

      };

    default: return { ...state };
  }
}
